import { render, staticRenderFns } from "./NewPaymentMethodAdd.vue?vue&type=template&id=67aa37a2&scoped=true"
import script from "./NewPaymentMethodAdd.vue?vue&type=script&lang=js"
export * from "./NewPaymentMethodAdd.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentMethodAdd.vue?vue&type=style&index=0&id=67aa37a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa37a2",
  null
  
)

export default component.exports